<template>
    <div v-if="coloredProduct.saleCountdownText" class="product-sale-countdown">
        <i class="product-countdown-icon-lightning"></i>
        <!-- 4&nbsp;dni do konca zľavy -->
        {{ coloredProduct.saleCountdownText }}
    </div>
</template>

<script>
export default {
    props: {
        coloredProduct: { type: Object, required: true },
    },
};
</script>

<style lang="scss" scoped></style>
